import { Select, Loader, Group, Text } from "@mantine/core";
import { IconCircleCheck } from "@tabler/icons-react";
import type { FlowVersionSummaryViewModel } from "@models/doctype";
import "./VersionSelector.scss";

interface VersionSelectorProps {
    versions: FlowVersionSummaryViewModel[];
    selectedVersion: FlowVersionSummaryViewModel | null;
    onVersionChange: (version: FlowVersionSummaryViewModel) => void;
    isLoading?: boolean;
}

export const VersionSelector = ({
    versions,
    selectedVersion,
    onVersionChange,
    isLoading = false,
}: VersionSelectorProps) => {
    const getVersionKey = (version: FlowVersionSummaryViewModel) =>
        `${version.flowBaseId}-${version.version}`;

    const data = versions.map((version) => ({
        value: getVersionKey(version),
        label: `Version ${version.version}${version.isActive ? " ✓" : ""}`,
    }));

    return (
        <Select
            className="version-selector"
            value={selectedVersion ? getVersionKey(selectedVersion) : null}
            onChange={(value) => {
                const version = versions.find((v) => getVersionKey(v) === value);
                if (version) onVersionChange(version);
            }}
            data={data}
            size="sm"
            disabled={isLoading}
            rightSection={isLoading ? <Loader size={16} /> : undefined}
            comboboxProps={{ withinPortal: false }}
            renderOption={({ option }) => {
                const version = versions.find((v) => getVersionKey(v) === option.value);
                return (
                    <Group gap="xs" className="version-selector__item">
                        <Text size="sm">Version {version?.version}</Text>
                        {version?.isActive && <IconCircleCheck size={16} color="green" />}
                    </Group>
                );
            }}
        />
    );
};
